export const en = {
    'disabled-note': 'You can generate a maximum of {count} keywords',
    generate: 'Combine keywords',
    'note-expanded-mode':
        'Keyword Generator allows you to create a set of keywords by mixing the added keywords in any combination. You can add up to 7 groups of keywords.',
    'note-hidden-mode': 'You can create new keywords by multiplying up to 7 groups of keywords.',
    title: 'Keyword Generator'
};
